import { useRestApi } from "@/shared/api"
import { IAppVersionCheckRequest } from "./model"

const { request } = useRestApi()

export async function checkAppVersionApi(payload: IAppVersionCheckRequest) {
    return request({
        url: "app-version/check",
        method: "POST",
        data: payload
    }, true)
}
